import React from 'react';
import Layout from '@/components/Layout';
import Search from '../../containers/Search';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import { useSetSSRStore, useSSRSelector } from '../../redux';
import { getSSRStoreData } from '../../utils/ssrPageData';
import { getRequiredCtxProps } from 'src/utils/getRequiredCtxProps';

const SearchPage = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);
  return (
    <Layout
      store={storeInfo}
      title={`${storeInfo?.store_info?.name} - Search product, Now Shop Online`}
      Icon={storeInfo?.store_info?.logo_image}
      metaDescription={
        'Now order online from my whatsapp store & pay using 150+ UPI Apps'
      }
      isCustomDomain={props.isCustomDomain}
      {...props}
    >
      <Search {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return { props: {} };

  let propData = {
    catalogCategories: [],
    catalogTags: [],
    collections: [],
  };

  const propType = await getSSRStoreData(ctx, {
    additionalDataToFetch: ['collections', 'categories'],
  });
  const extraProps = getRequiredCtxProps(ctx, propType);

  propData = { ...propData, ...propType };

  return { props: { ...propData, ...extraProps } };
}

export default SearchPage;
